export const initialLightBoxState = (props)=>({
        isOpen: false,
        imgOrientation: 'landscape',
        updateIsOpen: ()=>null
    });
